"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filters = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const ramda_1 = require("ramda");
const filter_row_1 = require("./filter-row");
const filters_styles_1 = require("./filters.styles");
const filter_model_1 = require("../filter.model");
const filter_utils_1 = require("../filter.utils");
const localization_1 = require("../../../../localization");
const store_1 = require("../../../../store");
const DEFAULT_ADVANCED_FILTER = {
    field: null,
    operator: null,
    value: '',
    connector: null,
};
const Filters = ({ updateFilter, }) => {
    const advancedFilterData = (0, store_1.useAdvancedViewerFilterData)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const addFilter = () => (0, ramda_1.pipe)((defaultFilter, filtersList) => (0, ramda_1.append)(defaultFilter, filtersList), updateFilter)(DEFAULT_ADVANCED_FILTER, advancedFilterData);
    const clearAllFilters = () => updateFilter([]);
    const removeFilter = (index) => {
        (0, ramda_1.pipe)((index, removalNum, advFilters) => (0, ramda_1.remove)(index, removalNum, advFilters), updateFilter)(index, 1, advancedFilterData);
    };
    const setFilterByIndex = (index, value) => {
        (0, ramda_1.pipe)((index, value, advFilters) => (0, ramda_1.update)(index, value, advFilters), updateFilter)(index, value, advancedFilterData);
    };
    const handleChangeFilterField = (index, prevAdvancedFilter) => (field) => {
        if ((0, filter_utils_1.isDateFilter)(field)) {
            setFilterByIndex(index, Object.assign(Object.assign({}, prevAdvancedFilter), { field, operator: null, value: [] }));
        }
        else {
            setFilterByIndex(index, Object.assign(Object.assign({}, prevAdvancedFilter), { field, operator: null, value: null, fieldSpecifier: null }));
        }
    };
    const handleChangeFilterOperator = (index, prevAdvancedFilter) => (operator) => setFilterByIndex(index, (0, ramda_1.assoc)(filter_model_1.FilterOption.Operator, operator, prevAdvancedFilter));
    const handleChangeOperatorConnector = (index, prevAdvancedFilter) => (connector) => setFilterByIndex(index, (0, ramda_1.assoc)(filter_model_1.FilterOption.Connector, connector, prevAdvancedFilter));
    return (react_1.default.createElement(filters_styles_1.StyledFiltersContainer, null, react_1.default.createElement(filters_styles_1.StyledFilters, null, advancedFilterData.map((advancedFilter, index) => {
        const { operator, field, value, connector, fieldSpecifier, } = advancedFilter;
        const handleChangeOperator = handleChangeFilterOperator(index, advancedFilter);
        const handleChangeField = handleChangeFilterField(index, advancedFilter);
        const handleRemoveFilter = () => removeFilter(index);
        const handleUpdateFilterByIndex = (value) => setFilterByIndex(index, value);
        const handleChangeConnector = handleChangeOperatorConnector(index, advancedFilter);
        const componentProps = {
            operator,
            field,
            firstRow: index === 0,
            onChangeField: handleChangeField,
            onChangeOperator: handleChangeOperator,
            filter: advancedFilter,
            onRemoveFilter: handleRemoveFilter,
            onUpdateFilter: handleUpdateFilterByIndex,
            onChangeConnector: handleChangeConnector,
            value,
            connectorOperator: connector,
        };
        return (0, filter_utils_1.isDateFilter)(field)
            ? react_1.default.createElement(filter_row_1.DateFilter, Object.assign({ key: index }, componentProps))
            : react_1.default.createElement(filter_row_1.ValueFilter, Object.assign(Object.assign({ key: index }, componentProps), { fieldSpecifier: fieldSpecifier }));
    })), react_1.default.createElement(filters_styles_1.StyledButtonWrapper, null, react_1.default.createElement(filters_styles_1.StyleFilterButton, { rounded: true, variant: "outlined", startIcon: react_1.default.createElement(ui_components_1.Icon, { variant: "addRounded", color: ui_components_1.baseColors.black }), title: t({ key: 'ADD_FILTER' }), onClick: addFilter }), advancedFilterData.some(({ field, value, operator }) => (field || value || operator)) ? (react_1.default.createElement(filters_styles_1.StyleFilterButton, { rounded: true, color: 'error', error: true, className: "clear", variant: "outlined", endIcon: react_1.default.createElement(ui_components_1.Icon, { variant: "delete", color: ui_components_1.baseColors.darkRed }), title: t({ key: 'CLEAR_ALL_FILTERS' }), onClick: clearAllFilters })) : null)));
};
exports.Filters = Filters;
exports.default = exports.Filters;
